export enum CollapsibleModifier {
  ADD_CONTENT_BLOCK_FORM = `collapsible-overlay--add-content-block-form`,
  BREADCRUMB_FLYOUT_PANEL = `collapsible-overlay--breadcrumb-flyout-panel`,
  FORM_HELP = `collapsible-overlay--form-help`,
  FORM_HELP_BOTTOM_RIGHT = `collapsible-overlay--form-help-bottom-right`,
  FORM_HELP_RIGHT_CENTER = `collapsible-overlay--form-help-right-center`,
  FORM_MULTISELECT = `collapsible-overlay--form-multiselect`,
  FORM_MULTISELECT_CHANGE_ROLE = `collapsible-overlay--form-multiselect-change-role`,
  FORM_MULTISELECT_FACET = `collapsible-overlay--form-multiselect-facet`,
  FILTER_BUTTON = `collapsible-overlay--filter-button`,
  PAGE_INTERACTIONS = `collapsible-overlay--page-interactions`,
  PAGE_INTERACTIONS_WATCH = `collapsible-overlay--page-interactions-watch`,
  PAGE_MANAGEMENT = `collapsible-overlay--page-management`,
  PERSON_PROFILE_IMAGE_SMALL = `collapsible-overlay--person-profile-image-small`,
  SELECT_LINKS = `collapsible-overlay--select-links`,
  PAGE_STATE = `collapsible-overlay--page-state`,
  PAGE_STATE_PUBLISHED = `collapsible-overlay--page-state-published`,
  CONTEXT_MENU = `context-menu`,
  CONTEXT_MENU_CENTERED = `collapsible-overlay--context-menu-centered`,
  SEARCH_TEXT_SNIPPET = `collapsible-overlay--search-text-snippet`,
}
